import {
  SET_PUBLISH_LIST,
  SET_PUBLISH_LIST_PAGE,
  SET_PUBLISH_LIST_PAGE_SIZE,
  SET_PUBLISH_LIST_PAGE_SIZE_TOTAL,
  SET_PUBLISH_LIST_QUERY,
  SET_PUBLISH_LIST_SEARCHING,
  SET_PUBLISH_SORT,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  publishId: '',
  productTaskId: '',
  userName: '',
  userId: '',
  status: 20,
  areaIds: '',
  publishIdFlag: '',       // int-根据发布作业ID排序，值为1为升序，值为0为降序，否则为空
  publishJobIdFlag: '',            // int-根据共享ID排序，值为1为升序，值为0为降序，否则为空
  startTimeFlag: '',           // int-根据开始时间排序，值为1为升序，值为0为降序，否则为空
  completedTimeFlag: '',            // int-根据结束时间帧排序，值为1为升序，值为0为降序，否则为空
  durationFlag: '',             // int-根据时长排序，值为1为升序，值为0为降序，否则为空
  consumeFlag: '',               // int-根据应付费用排序，值为1为升序，值为0为降序，否则为空
})

const state = {
  searching: false,
  initQuery: initQuery(),
  publish: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
    sort: {
      startTimeFlag: 0,
    },
  },
}

const mutations = {
  [SET_PUBLISH_LIST] (state, payload) {
    state.publish.list = payload
  },
  [SET_PUBLISH_LIST_PAGE] (state, payload) {
    state.publish.query.pageNum = payload
  },
  [SET_PUBLISH_LIST_PAGE_SIZE] (state, payload) {
    state.publish.query.pageSize = payload
  },
  [SET_PUBLISH_LIST_PAGE_SIZE_TOTAL] (state, payload) {
    state.publish.listPageTotal = payload
  },
  [SET_PUBLISH_LIST_QUERY] (state, payload) {
    state.publish.query = {
      ...state.publish.query,
      ...payload,
    }
  },
  [SET_PUBLISH_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_PUBLISH_SORT] (state, payload) {
    state.publish.sort = payload
  },
}

const actions = {
  // 获取发布列表
  async setPublishList ({commit, state}, payload) {
    try {
      let query = {}
      _.forIn(state.publish.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      query['areaIds'] = +query['areaIds']
      const params = {
        ...query,
        ...state.publish.sort,
        pageNum: state.publish.query.pageNum,
        pageSize: state.publish.query.pageSize,
      }
      const {data: {items, total}} = await api.dayanTaskApi.getTaskPublishList(params)
      commit(SET_PUBLISH_LIST_SEARCHING, false)
      commit(SET_PUBLISH_LIST_PAGE_SIZE_TOTAL, total)
      commit(SET_PUBLISH_LIST, items)
    } catch (error) {
      commit(SET_PUBLISH_LIST, [])
      commit(SET_PUBLISH_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  async changePublishListPage({commit, state, dispatch}, payload) {
    commit(SET_PUBLISH_LIST_PAGE, payload.currentPage)
    await dispatch('setPublishList')
  },
  initPublishList ({commit, dispatch}) {
    const query = initQuery()
    commit(SET_PUBLISH_LIST_QUERY, query)
    dispatch('changePublishListPage', {currentPage: 1})
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_PUBLISH_LIST_SEARCHING, true)
    commit(SET_PUBLISH_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changePublishListPage', {currentPage: 1})
  },
  changeQuery ({commit}, payload) {
    commit(SET_PUBLISH_LIST_QUERY, payload)
  },
  // 排序
  changePublishSort ({commit, dispatch}, payload) {
    commit(SET_PUBLISH_SORT, payload)
    dispatch('changePublishListPage', {currentPage: 1})
    dispatch('setPublishList')
  },
  // 重置排序
  resetPublishSort ({dispatch}) {
    dispatch('changePublishSort', {})
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
